// extracted by mini-css-extract-plugin
export var searchHeader = "_q-0";
export var searchHeaderDark = "_q-1";